<template>
  <div class="uploadbtn">
    <el-upload
      class="upload-demo"
      :action="uploadImgUrl"
      :on-success="handleUploadSuccess"
      multiple
      :limit="1"
      :file-list="fileList"
      :before-upload="handleBeforeUpload"
      :headers="headers"
      :on-remove="handleDelete"
      :on-exceed="handleExceed"
    >
      <slot></slot>
      <span v-if="showTip">
        请上传
        <template v-if="fileSize">
          大小不超过
          <b style="color: #f56c6c">{{ fileSize }}MB</b>
        </template>
        的文件
        <b style="color: #f56c6c">（数量限制1个）</b>
      </span>
    </el-upload>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth'
export default {
  // 组件名称
  name: '',
  components: {},
  props: {
    fileSize: {
      type: Number,
      default: 5,
    },
    fileType: {
      type: Array,
      default: () => ['png', 'jpg', 'jpeg'],
    },
    limit: {
      type: Number,
      default: 1,
    },
    value: [String, Object, Array],
    isShowTip: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      fileList: [],
      uploadImgUrl: process.env.VUE_APP_BASE_API + '/classspace/file/upload',
      headers: {
        Authorization: 'Bearer ' + getToken(),
      },
      baseUrl: '',
    }
  },
  computed: {
    showTip() {
      return this.isShowTip
    },
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          // 首先将值转为数组
          const list = Array.isArray(val) ? val : this.value.split(',')
          // 然后将数组转为对象数组
          this.fileList = list.map((item) => {
            if (typeof item === 'string') {
              if (item.indexOf(this.baseUrl) === -1) {
                item = { name: this.baseUrl + item, url: item }
              } else {
                item = { name: item, url: item }
              }
            }
            return item
          })
        } else {
          this.fileList = []
          return []
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    handleBeforeUpload(file) {
      if (this.fileSize) {
        const isLt = file.size / 1024 / 1024 < this.fileSize
        if (!isLt) {
          this.$message.error(`上传头像图片大小不能超过 ${this.fileSize} MB!`)
          return false
        }
      }
    },
    handleUploadSuccess(res, file) {
      if (res.code == 200) {
        this.$emit('input', res.data)
        this.$message.success('文件上传成功!')
      }
    },
    handleDelete() {
      this.fileList = []
    },
    handleExceed() {
      this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`)
    },
  },
}
</script>

<style scoped lang="less"></style>
